export default "__VITE_ASSET__cd8c3af5__"